import { useQuery, UseQueryOptions } from "react-query";

import { mapAgentOfficeApiData } from "mappers";
import { agentOfficeSetupService } from "services";

type UseGetAgentOfficeApiQueryProps = {
	companyId: string;
	options?:
		| Omit<
				UseQueryOptions<any, unknown, any, string[]>,
				"queryKey" | "queryFn"
		  >
		| undefined;
};

const useGetAgentOfficeApiQuery = ({
	companyId,
	options,
}: UseGetAgentOfficeApiQueryProps) => {
	return useQuery(
		["getAgentOfficeApi", companyId],
		() => agentOfficeSetupService.getAgentOfficeApi({ companyId }),
		{
			select: data => mapAgentOfficeApiData(data),
			enabled: !!companyId,
			...options,
		},
	);
};

export default useGetAgentOfficeApiQuery;
